import React, { useState, useEffect } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import Modal from "../Modal";

const { REACT_APP_BACKEND_URL } = process.env;

const UpdateSenderAdd = ({ isOpen, onClose, onSave, PickupAddress, title }) => {
  const [formData, setFormData] = useState({
    contactName: "",
    email: "",
    phoneNumber: "",
    address: "",
    pinCode: "",
    city: "",
    state: "",
  });

  useEffect(() => {
    if (PickupAddress) {
      setFormData({
        contactName: PickupAddress.contactName || "",
        email: PickupAddress.email || "",
        phoneNumber: PickupAddress.phoneNumber || "",
        address: PickupAddress.address || "",
        pinCode: PickupAddress.pinCode || "",
        city: PickupAddress.city || "",
        state: PickupAddress.state || "",
      });
    }
  }, [PickupAddress]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handlePincodeChange = async (e) => {
    handleChange(e);
    const enteredPincode = e.target.value;

    if (enteredPincode.length === 6) {
      try {
        const token = document.cookie.split("=")[1];
        const response = await axios.get(
          `${REACT_APP_BACKEND_URL}/order/pincode/${enteredPincode}`,
          {
            headers: { authorization: `Bearer ${token}` },
          }
        );

        if (response.data) {
          setFormData((prev) => ({
            ...prev,
            city: response.data.city,
            state: response.data.state,
          }));
        } else {
          setFormData((prev) => ({ ...prev, city: "", state: "" }));
          toast.error("Pincode not found!");
        }
      } catch (error) {
        console.error("Error fetching city/state for pincode:", error);
        toast.error("Failed to fetch city/state.");
        setFormData((prev) => ({ ...prev, city: "", state: "" }));
      }
    } else {
      setFormData((prev) => ({ ...prev, city: "", state: "" }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (onSave) {
      onSave(formData);
    }
    onClose(); // close modal after save
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={<span className="sm:text-[14px] text-[12px] font-[600] p-2 text-gray-700">{title || "Update Sender Address"}</span>}
    >
      <form className="grid grid-cols-2 gap-4 text-[12px] font-[600] text-gray-500" onSubmit={handleSubmit}>
        <div className="font-[600] text-gray-500">
          <label className="block font-[600]">
            Contact Name <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="contactName"
            value={formData.contactName}
            onChange={handleChange}
            placeholder="Enter Contact Name"
            className="w-full px-3 py-2 rounded-lg border-2 focus:outline-green-200"
          />
        </div>
        <div>
          <label className="block font-[600]">
            Email <span className="text-red-500">*</span>
          </label>
          <input
            type="email"
            name="email"
            value={formData.email}
            onChange={handleChange}
            placeholder="buyer.contact@shift.in"
            className="w-full py-2 px-3 border-2 rounded-lg focus:outline-green-200"
          />
        </div>
        <div>
          <label className="block font-[600]">
            Phone Number <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="phoneNumber"
            value={formData.phoneNumber}
            onChange={handleChange}
            placeholder="Enter Phone Number"
            className="w-full py-2 px-3 border-2 rounded-lg focus:outline-green-200"
          />
        </div>
        <div>
          <label className="block font-[600]">
            Address <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="address"
            value={formData.address}
            onChange={handleChange}
            placeholder="Enter Address"
            className="w-full px-3 py-2 border-2 rounded-lg focus:outline-green-200"
          />
        </div>
        <div>
          <label className="block font-[600]">
            Pincode <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="pinCode"
            value={formData.pinCode}
            onChange={handlePincodeChange}
            placeholder="Enter Pincode"
            className="w-full px-3 py-2 border-2 rounded-lg focus:outline-green-200"
          />
        </div>
        <div>
          <label className="block font-[600]">
            City <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="city"
            value={formData.city}
            onChange={handleChange}
            placeholder="Enter City"
            className="w-full px-3 py-2 border-2 rounded-lg focus:outline-green-200"
          />
        </div>
        <div>
          <label className="block font-[600]">
            State <span className="text-red-500">*</span>
          </label>
          <input
            type="text"
            name="state"
            value={formData.state}
            onChange={handleChange}
            placeholder="Enter State"
            className="w-full px-3 py-2 border-2 rounded-lg focus:outline-green-200"
          />
        </div>
        <div className="col-span-2 text-right">
          <button type="submit" className="bg-[#0CBB7D] text-white px-3 py-2 text-[12px] rounded-lg">
            Save
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default UpdateSenderAdd;
